export default [{type:"image\u002Fwebp",srcset:".\u002Fassets\u002Fmiyagod.6944a258.webp 325w",loading:"lazy",src:".\u002Fassets\u002Fmiyagod.6944a258.webp"}]